export const AGENT_ROLE_NAMES: readonly string[] = ['agent', 'نماینده'];

export const SECRETARY_ROLE_NAMES: readonly string[] = ['secretary', 'منشی'];

export const OPERATOR_CARD_STAFF_ROLE_NAMES: readonly string[] = [
  ...SECRETARY_ROLE_NAMES,
  'support',
  'پشتیبانی',
  'پشتیبان',
];

export const AGENT_ACCESS_ROLE_NAMES: readonly string[] = [
  ...AGENT_ROLE_NAMES,
  ...SECRETARY_ROLE_NAMES,
];

export const CHECKOUT_FOR_USER_ROLE_NAMES: readonly string[] = [
  'admin',
  'support',
  'پشتیبانی',
  'operator',
  'اپراتور',
  ...AGENT_ROLE_NAMES,
];

export function isAgentAccessRole(roleName?: string | null): boolean {
  const normalizedRoleName = String(roleName || '').trim().toLowerCase();

  return AGENT_ACCESS_ROLE_NAMES.includes(normalizedRoleName);
}
